import { Injectable, inject } from '@angular/core';
import {
    LorenUsersEndpointsService
} from '../../../../shared/services/loren-users-endpoints-service/loren-users-endpoints.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class LorenUserServiceService {
    private lorenHttpService = inject(HttpClient);
    private lorenUsersEndpointsService = inject(LorenUsersEndpointsService);


    deleteUserProfilePicture(userId: number) {
        return this.lorenHttpService.delete<void>(this.lorenUsersEndpointsService.images(userId));
    }
}
